import './polyfills';
import '@cars4ever/public-ui/dist/index.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { gtmHelpers } from '@digital-dealer/utils';

import App from './App';

gtmHelpers.init();

const container = document.getElementById('root');

if (container) {
  createRoot(container).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
